




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import NewContainer from '@/containers/cv-section-date-item/new.vue';
import * as CvSectionDateItemStoreNew from '@/store/modules/cvSectionDateItemNew';

const { mapGetters } = createNamespacedHelpers(
  CvSectionDateItemStoreNew.namespace
);

const fetch = async params => {
  const { cv_id, cv_section_date_id } = params;
  await Promise.all([
    store.dispatch(
      CvSectionDateItemStoreNew.GetCvSectionDate.namespaced({
        params: { cv_id, id: cv_section_date_id },
      })
    ),
  ]);
};

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionDateItemStoreNew],
    };
  },
  computed: {
    ...mapGetters(['cvSectionDate']),
  },
});
